import { create } from 'zustand';
import axiosToken from '../api/axiosClient';

const useOpeningHoursStore = create((set) => ({
    // Heures d'ouverture par défaut (peuvent être chargées depuis une API)
    openingHours: {
        0: [], // Dimanche fermé
        1: ["08:00 - 12:00", "14:00 - 18:00"], // Lundi
        2: ["09:00 - 12:00", "14:00 - 18:00"], // Mardi
        3: ["09:00 - 12:00", "14:00 - 18:00"], // Mercredi
        4: ["09:00 - 12:00", "14:00 - 18:00"], // Jeudi
        5: ["09:00 - 12:00", "14:00 - 18:00"], // Vendredi
        6: ["09:00 - 12:00"], // Samedi (fermé l'après-midi)
    },

    // Charger les heures depuis une API
    loadOpeningHours: async () => {
        try {
            // Exemple de requête API (à adapter)
            const response = await axiosToken.get('/api/opening-hours');
            // const data = await response.json();

            set({ openingHours: response });
        } catch (error) {
            console.error("Erreur lors du chargement des heures d'ouverture:", error);
        }
    },

    // Mettre à jour les heures d'ouverture
    updateOpeningHours: (day, hours) => {
        set((state) => ({
            openingHours: {
                ...state.openingHours,
                [day]: hours,
            },
        }));
    },

    // Récupérer les heures pour un jour spécifique
    getHoursForDay: (day) => {
        return useOpeningHoursStore.getState().openingHours[day] || [];
    },
}));

export default useOpeningHoursStore;